module.exports = __webpack_public_path__ + "img/verif-article.27cd8e8d.png";